import React, { useState, useCallback } from 'react';

interface SearchBarProps {
  onSearchChange: (query: string) => void;
  placeholder?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({ 
  onSearchChange, 
  placeholder = 'Search groups and vehicles...' 
}) => {
  const [query, setQuery] = useState('');

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const newQuery = event.target.value;
    setQuery(newQuery);
    onSearchChange(newQuery);
  }, [onSearchChange]);

  const handleClear = useCallback(() => {
    setQuery('');
    onSearchChange('');
  }, [onSearchChange]);

  return (
    <div className="search-bar">
      <div className="search-input-wrapper">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          value={query}
          onChange={handleChange}
          placeholder={placeholder}
          className="search-input"
          aria-label="Search"
        />
        {query && (
          <button
            onClick={handleClear}
            className="search-clear"
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};
